import React from 'react';

import { Drawer as MuiDrawer } from '@mui/material';

const APP_BAR_HEIGHT = 64;

export default function Drawer({
  open,
  onRequestClose,
  children,
  width = 256,
  docked = true,
  containerStyle,
  openSecondary = false,
}: {
  open?: boolean;
  onRequestClose?: () => void;
  children?: React.ReactNode;
  width?: number;
  docked?: boolean;
  containerStyle?: React.CSSProperties;
  openSecondary?: boolean;
}) {
  const anchor = openSecondary ? 'right' : 'left';

  return (
    <MuiDrawer
      variant={docked ? 'permanent' : 'temporary'}
      anchor={anchor}
      open={open ?? true}
      onClose={onRequestClose}
      ModalProps={{ keepMounted: false }}
      sx={{
        width: docked ? width : undefined,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width,
          display: 'flex',
          flexDirection: 'column',
          boxSizing: 'border-box',
          borderRight: anchor === 'left' ? 'none' : undefined,
          borderLeft: anchor === 'right' ? 'none' : undefined,
          ...(docked
            ? containerStyle
            : {
                top: APP_BAR_HEIGHT,
                height: `calc(100% - ${APP_BAR_HEIGHT}px)`,
                ...containerStyle,
              }),
        },
      }}
    >
      {children}
    </MuiDrawer>
  );
}

export { Drawer };
